module.exports = __webpack_public_path__ + "static/10400556_21565057223_9639_n-2131d551edc47e77a7b6c160a91cd603.jpg";